<template>
    <div
        class="kleptos-window-manager"
        :style="windowManagerStyle">

        <!-- TRANSITION GROUP -->
        <transition-group
            class="transition-group"
            name="transitionEnter"
            tag="div"
        >
            <!-- WINDOW MANAGER DRAGGER -->
            <KleptOSWindowManagerDragger
                v-for="(item, index) in windows"
                :key="item.uuid"
                :game-object="item"
                :res-width="resWidth"
                :res-height="resHeight"
                :style="item.windowData.minimized ? { 'pointer-events': 'none' } : {}"
                :class="{ 'is-minimized': item.windowData.minimized }"
            >
                <!-- WINDOW -->
                <transition
                    name="transitionMinimize"
                    @enter="(el, done) => { enterTransition(el, done, item.uuid) }"
                    @leave="(el, done) => { leaveTransition(el, done, item.uuid) }"
                >
                    <KleptOSWindow
                        v-show="!item.windowData.minimized"
                        :game-object="item"
                    />
                </transition>

            </KleptOSWindowManagerDragger>
        </transition-group>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import WindowManagerDragger from './WindowManagerDragger';
    import WindowManagerWindow from './WindowManagerWindow';

    export default {
        components: {
            KleptOSWindow: WindowManagerWindow,
            KleptOSWindowManagerDragger: WindowManagerDragger
        },
        data(){
            return {
                // get the POTENTIAL **MAX** screen size of the user
                resWidth: window.screen.availWidth,
                resHeight: window.screen.availHeight
            }
        },
        computed: {
            ...mapGetters({
                windows: 'gameOS/getWindows',
            }),
            windowManagerStyle() {
                return {
                    left: -this.resWidth + 'px', // how far windows can drag offscreen left and right
                    width: this.resWidth*3 + 'px', // offsetL | client | offsetR
                    height: this.resHeight*2 + 'px' // client top, offsetY below
                }
            }
        },
        methods: {
            //--------------------------------------------------------------------
            // TRANSITIONS
            //--------------------------------------------------------------------

            enterTransition(el, done, uuid) {
                el.style.transform = 'translateY(0) translateX(0)';
                el.style.opacity = 1;
                // done(); -- don't need b/c we also allow CSS sniffing
            },

            leaveTransition(el, done, uuid) {
                const taskbarBtnBounds = document.querySelector('.kleptos-taskbar-panel-btn[data-uuid="'+uuid+'"]').getBoundingClientRect();
                const diffX = taskbarBtnBounds.left - el.getBoundingClientRect().left;
                const diffY = document.documentElement.clientHeight - el.getBoundingClientRect().top;

                el.style.transform = 'translate('+ diffX +'px, '+ diffY +'px) scale(0.2)';
                el.style.opacity = 0;
            }
        }
    }
</script>

<style lang="scss" scoped>

    //--------------------------------------------------------------------
    // TRANSITIONS
    //--------------------------------------------------------------------

    .transitionEnter-enter-active,
    .transitionEnter-leave-active {
        transition: all 150ms ease;
    }

    .transitionEnter-enter,
    .transitionEnter-leave-to {
        transform: scale(0.95);
        opacity: 0;
    }

    //--------------------------------------------------------------------
    // TRANSITION MINIMIZE
    //--------------------------------------------------------------------

    .transitionMinimize-enter-active,
    .transitionMinimize-leave-active {
        transition: transform 300ms ease, opacity 10ms 305ms linear;
        transform-origin: left top;
    }

    .transitionMinimize-enter-active {
        transition: transform 300ms ease, opacity 0ms 0ms ease;
    }

    //--------------------------------------------------------------------
    // WINDOW MANAGER
    //--------------------------------------------------------------------

    .kleptos-window-manager {
        position: absolute;
        top: rem-calc(40); // TODO: variable this
        overflow: hidden;
        // background: #41b884; // keep for reference with Chrome layers
    }

    .transition-group {
        width: 100%;
        height: 100%;
    }
</style>